module.exports = __webpack_public_path__ + "static/jenkins-c1c2d5ac94b345d3ef7a91df738810d8.svg";